const Routes = [
	{
		path: '/livechat',
		name: 'LiveChat',
		component: () => import(/* webpackChunkName: "LiveChat" */ '@/pages/LiveChat/LiveChat.vue'),
		meta: {
			title: 'LiveChat',
			cleanWindow: true,
		},
	},
];

export default Routes;
